import { render, staticRenderFns } from "./TemplatesAll.vue?vue&type=template&id=4e2900dd&scoped=true"
import script from "./TemplatesAll.vue?vue&type=script&lang=js"
export * from "./TemplatesAll.vue?vue&type=script&lang=js"
import style0 from "./TemplatesAll.vue?vue&type=style&index=0&id=4e2900dd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2900dd",
  null
  
)

export default component.exports